import { generateLongitudeModal } from '../../LongitudeModal';
import { generateLatitudeModal } from '../../LatitudeModal';

const comments = 'The event coordinates of over 800 tsunami sources in this database are not known and the latitude and longitude are listed as null. Therefore, to retrieve all the events from a particular country or state, leave the event coordinates search parameter blank and enter the country or select the region name.';

export const TsuLongitudeModal = generateLongitudeModal({ comments });

export const TsuLatitudeModal = generateLatitudeModal({ comments });
